// extracted by mini-css-extract-plugin
export default {"dlIconButton":"src-js-components-IconButton---dlIconButton---nQ3fP","dlDisabled":"src-js-components-IconButton---dlDisabled---jVU2y"};